import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import employee from "../../../containers/modules/hr/employee";

export default function EmployeeRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="employee"
      index
      element={
        <AccessControl
          name={"Employee List"}
          auth={authUser}
          component={employee}
        />
      }
    ></Route>
  );
}
